import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ToolEnum } from '../../models/tool.enum';
import { Select, Store } from '@ngxs/store';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { Observable } from 'rxjs';
import { ZoomCamera, SetCamera, SetPanMode } from '../../state/camera/engine.camera.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { CenterCameraOnVisible } from '../../state/engine.actions';

@Component({
  selector: 'app-engine-camera-bar',
  templateUrl: './engine-camera-bar.component.html',
  styleUrls: ['./engine-camera-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EngineCameraBarComponent implements OnInit {
  toolEnum = ToolEnum;

  @Input()
  showCenter = false;

  @Select(EngineCameraState.getPanMode)
  panMode$: Observable<string>;

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
  }

  setZoom(state: 'in' | 'out' | '') {
    let zoomValue = (state === '') ? 0 : 8;
    zoomValue = (state === 'in') ? -zoomValue : zoomValue;
    
    this.store.dispatch(new ZoomCamera(zoomValue));
  }

  returnToChapterCamera() {
    const chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
    this.store.dispatch(new SetCamera(chapter.camera.location));
  }

  centerCamera() {
    this.store.dispatch(new CenterCameraOnVisible());
  }

  togglePan() {
    const mode = this.store.selectSnapshot(EngineCameraState.getPanMode) === 'pan' ? 'rotate' : 'pan';
    this.store.dispatch(new SetPanMode(mode));
  }
}
